import {reportYear,entityOaid} from '../../util/util'
export default{
  delimiters: ['{', '}'],
  props: {

  },
  data: () => {
    return {
      oaid: null,
      industry: "",
      officialName: "",
      report_date: [],
    }
  },
  methods: {
    callIndicationTable(){
      let id = this.$route.params.oaid
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_date = result.report_annual_list
      })
      entityOaid.oaid(id).then(result => {
        self.oaid =result
      })
    }
  },
  mounted () {
    this.callIndicationTable()
  }
}



// WEBPACK FOOTER //
// ./src/esg/js/esg_private_entity_indicator.js